export default __webpack_public_path__ + "static/media/GuessJobs2_06.64890c33.png";